var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coverInnerSeparationEnabled)?_c('BookCreateV2'):_c('BookCreate')
}
var staticRenderFns = []

export { render, staticRenderFns }